import {Component, Watch} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import query from '@/components/query/query-constructor';

import commonFilter from '@/components/query/commonFilter';
import UrlMixin from '@/components/query/url-mixin';

import { pushURL } from './utils';
import { pushURL as pushURLConversions } from '@/views/reports/pickers/base/conversions/utils';
import { pushURL as pushURLPostbacks } from '@/views/reports/pickers/base/postbacks/utils';
import { pushURL as pushURLErrors } from '@/views/reports/pickers/base/errors/utils';
import { pushURL as pushURLLiveClicks } from '@/views/reports/pickers/base/live-clicks/utils';
import { pushURL as pushURLLiveVisits } from '@/views/reports/pickers/base/live-visits/utils';
import { pushURL as pushURLDashboard } from '@/views/dashboard/pickers/base/utils';

type Query = {
  action: string,
  path: string
}

@Component
export default class PickersCache extends mixins(UrlMixin) {
  value: any;
  param: any;
  range: any;
  silent: boolean = false;
  refresh: boolean = false;

  get routeName() {
    const { name } = this.$route;
    return name
  }

  pick(param: string, value: any = null) {
    const cache: any = query.decode(this.$route.params.data as string) || this.$store.getters.reportParams;

    return cache 
      ? typeof(cache[param]) !== 'undefined' 
        ? cache[param] 
        : value
      : null;
  }

  get storeSource(): Query {
    switch(this.routeName) {
      case 'app.index':
        return {
          action: 'dashboardQueryTemporary',
          path: 'dashboard.queryTemporary'
        };

      default:
        return {
          action: 'tableQuery',
          path: 'table.query'
        };
    }
  }

  cache(pick: boolean = false, param: string = this.param, value: any = this.value) {
    if(pick) {
      this.value = this.pick(param, value);
    }

    const data = {
      notSetToLocalStorage: this.isReport(),
      grouping: this.$route.params.type,
      ...(value && { value }),
      ...(param && {
        param,
        name: param
      }),
    };

    this.$store.commit(this.storeSource.action, data);

    this.commonFilter(data);
  }

  commonFilter(data: any = {}) {
    commonFilter(this, data);
  }

  //#GDB: pushURL
  get pushURL(): (...args: any[]) => any {
    switch(this.routeName) {
      case 'app.conversions':
        return this.pushURLCustom(pushURLConversions);
      case 'app.postbacks':
        return this.pushURLCustom(pushURLPostbacks);
      case 'app.errors':
        return this.pushURLCustom(pushURLErrors);
      case 'app.live-clicks':
        return this.pushURLCustom(pushURLLiveClicks);
      case 'app.live-visits':
        return this.pushURLCustom(pushURLLiveVisits);
      case 'app.index':
        return  this.pushURLDashboard;

      default:
        return this.pushURLSimple;
    }
  }

  pushURLDashboard(cb: () => void = null) {
    cb = cb || (() => {
      if (this.refresh) {
        this.bus.emit('refresh-dashboard');
      }
    })

    pushURLDashboard(this, cb);
  }

  pushURLSimple(cb: () => void = null) {
    cb = cb || (() => {
      if (this.refresh) {
        this.bus.emit('refresh-report');
      }
    })

    pushURL(this, cb);
  }

  pushURLCustom(pushURLFunction: Function) {
    return (cb: () => void = null) => {
      cb = cb || (() => {
        if (this.refresh && !this.$filter.isSet) {
          //setTimeout(() => this.bus.emit('refresh-report'), 10);
          this.bus.emit('refresh-report');
        }
      })

      pushURLFunction(this, cb);
    }
  }

  @Watch('value')
  handle(){
    if (!this.silent) {
      this.pushURL();
    }
  }
}
